import { StreamEvent } from './model';

/** Incremental SSE decoder: handles UTF-8 chunk boundaries, CRLF and multiline data. */
export async function* readAgentStream(
  body: ReadableStream<Uint8Array>,
): AsyncGenerator<StreamEvent> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let event = 'message';
  let data: string[] = [];
  function line(value: string): StreamEvent | undefined {
    if (!value) {
      const raw = data.join('\n');
      const name = event;
      event = 'message';
      data = [];
      if (!raw) return;
      try {
        const payload: unknown = JSON.parse(raw);
        if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
          return { event: name, payload: payload as Record<string, unknown> };
        }
      } catch {
        // Heartbeats and malformed records do not enter application state.
      }
      return;
    }
    if (value.startsWith('event:')) event = value.slice(6).trim();
    if (value.startsWith('data:')) data.push(value.slice(5).replace(/^ /, ''));
  }
  try {
    while (true) {
      const chunk = await reader.read();
      buffer += decoder.decode(chunk.value, { stream: !chunk.done });
      let end: number;
      while ((end = buffer.indexOf('\n')) >= 0) {
        const parsed = line(buffer.slice(0, end).replace(/\r$/, ''));
        buffer = buffer.slice(end + 1);
        if (parsed) yield parsed;
      }
      if (chunk.done) break;
    }
    if (buffer) line(buffer.replace(/\r$/, ''));
    const last = line('');
    if (last) yield last;
  } finally {
    await reader.cancel().catch(() => undefined);
    reader.releaseLock();
  }
}
